import gatsbyTOC from "../../../../src/images/gatsby/gatsby_TOC.png";
import gatsbyTOCAutolinkHeaders from "../../../../src/images/gatsby/gatsby_TOC_autolink_headers.png";
import gatsbyTOCItems from "../../../../src/images/gatsby/gatsby_TOC_items.png";
import gatsbyTOCSassBefore from "../../../../src/images/gatsby/gatsby_TOC_sass_before.png";
import gatsbyTOCSassAfter from "../../../../src/images/gatsby/gatsby_TOC_sass_after.png";
import * as React from 'react';
export default {
  gatsbyTOC,
  gatsbyTOCAutolinkHeaders,
  gatsbyTOCItems,
  gatsbyTOCSassBefore,
  gatsbyTOCSassAfter,
  React
};